import React from "react";
import { Link, useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>404</h1>
      <h2 style={styles.subtitle}>Page Not Found</h2>
      <p style={styles.text}>
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>
      <div style={styles.buttonContainer}>
        <button style={styles.button} onClick={() => navigate(-1)}>🔙 Go Back</button>
        <Link to="/" style={{ textDecoration: "none" }}>
          <button style={styles.homeButton}>🏠 Home</button>
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F8F9FA",
  },
  title: {
    fontSize: "80px",
    fontWeight: "bold",
    color: "#2C3E50",
  },
  subtitle: {
    fontSize: "28px",
    fontWeight: "600",
    color: "#34495E",
    marginBottom: "10px",
  },
  text: {
    fontSize: "16px",
    color: "#7B8A8B",
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    gap: "15px",
  },
  button: {
    padding: "12px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    backgroundColor: "#3498DB",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  homeButton: {
    padding: "12px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    backgroundColor: "#2ECC71",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

export default NotFoundPage;
